module.exports = __webpack_public_path__ + "static/media/header_webinar.828c769e.jpg";